import {DELETE_POSTS_START} from "../../types";

export const delete_posts = (payload) => ({
    type: DELETE_POSTS_START,
    payload,
});